const MaltaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111840)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path d="M20 0C31.0456 0 40 8.95437 40 20C40 31.0456 31.0456 40 20 40" fill="#D80027" />
      <path
        d="M13.9127 7.82547V5.2168H11.3041V7.82547H8.69531V10.4341H11.3041V13.0429H13.9127V10.4341H16.5214V7.82547H13.9127Z"
        fill="#ACABB1"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111840">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MaltaSvg;
